import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_ARROW_DOWN_UP: GlameraIconDefinition = {
  name: 'arrow-down-up',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-arrow-down-up-down">
      <path d="m3 16 4 4 4-4"></path>
      <path d="M7 20V4"></path>
    </g>
    <g class="glm-arrow-down-up-up">
      <path d="m21 8-4-4-4 4"></path>
      <path d="M17 4v16"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-arrow-down-up-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './arrow-down-up.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ArrowDownUpIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_ARROW_DOWN_UP;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
